export default __webpack_public_path__ + "static/media/label_vod.b9dae5d4.svg";